import type { IntlShape } from 'react-intl';

export const defaultRichTextElements = {
  b: (text: React.ReactNode[]) => <strong>{text}</strong>,
  strong: (text: React.ReactNode[]) => <strong>{text}</strong>,
  i: (text: React.ReactNode[]) => <em>{text}</em>,
  em: (text: React.ReactNode[]) => <em>{text}</em>,
  u: (text: React.ReactNode[]) => <u>{text}</u>,
  mark: (text: React.ReactNode[]) => <mark>{text}</mark>,
  br: () => <br />,
};

export function createReactIntlConfig({
  messages,
}: {
  messages: {
    en: IntlShape['messages'];
    fr: IntlShape['messages'];
    de: IntlShape['messages'];
    es?: IntlShape['messages'];
    it?: IntlShape['messages'];
    nl?: IntlShape['messages'];
    pt?: IntlShape['messages'];
  };
}) {
  return {
    parameters: {
      defaultLocale: 'en',
      locales: ['en', 'fr', 'de', 'es', 'it', 'nl', 'pt'],
      messages,
      defaultRichTextElements,
    },
    initialGlobals: {
      locale: 'en',
      locales: {
        en: { icon: '🇺🇸', title: 'English', right: 'EN' },
        fr: { icon: '🇫🇷', title: 'Français', right: 'FR' },
        de: { icon: '🇩🇪', title: 'Deutsch', right: 'DE' },
        es: { icon: '🇪🇸', title: 'Español', right: 'ES' },
        it: { icon: '🇮🇹', title: 'Italiano', right: 'IT' },
        nl: { icon: '🇳🇱', title: 'Nederlands', right: 'NL' },
        pt: { icon: '🇵🇹', title: 'Português', right: 'PT' },
      },
    },
  };
}
